import React from 'react';
import { ButtonElement, ButtonElementProps } from './ButtonElement';
import { CustomLink } from '@/components/navigation';
import { LinkProps } from 'react-router-dom';

export type InternalLinkButtonProps = ButtonElementProps & LinkProps;

const InternalLinkButton: React.FC<InternalLinkButtonProps> = (props) => {
    return <ButtonElement tag={CustomLink} {...props} />;
};

export default InternalLinkButton;
